// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-card[data-v-7e523a73] {
  border-radius: 5px;
  margin: 10px;
  overflow: hidden;
  color: #555555;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px;
}
.product-card .header[data-v-7e523a73] {
  display: flex;
  flex-direction: row;
}
.product-card .header .image[data-v-7e523a73] {
  width: 84px;
  padding: 10px;
  flex-shrink: 0;
}
.product-card .header .headings[data-v-7e523a73] {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 15px;
}
.product-card .header .headings h1[data-v-7e523a73], .product-card .header .headings h2[data-v-7e523a73] {
  margin: 0;
  padding: 0;
}
.product-card .header .headings h1[data-v-7e523a73] {
  text-transform: uppercase;
  font-size: 18px;
}
.product-card .header .headings h2[data-v-7e523a73] {
  font-size: 14px;
}
.product-card .bottom[data-v-7e523a73] {
  box-shadow: inset 0 3px 5px #eee;
}
.product-card .bottom .body[data-v-7e523a73] {
  display: flex;
}
.product-card .bottom .body .left[data-v-7e523a73] {
  display: flex;
  align-items: flex-end;
  flex-shrink: 0;
  width: 84px;
  padding: 5px 0;
}
.product-card .bottom .body .left .expander[data-v-7e523a73] {
  width: 84px;
  display: flex;
  justify-content: center;
}
.product-card .bottom .body .content[data-v-7e523a73] {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-size: 16px;
  flex-grow: 1;
}
.product-card .bottom .body .content .text[data-v-7e523a73] {
  padding: 15px;
  font-size: 14px;
  width: 100%;
}
.product-card .bottom .body .content .actions[data-v-7e523a73] {
  display: flex;
  justify-content: flex-end;
  flex-grow: 1;
  padding: 5px 0;
}
.product-card[data-v-7e523a73] {
  background: #ffffff;
}
.ion-palette-dark .product-card[data-v-7e523a73] {
  background: #363636;
  color: white;
}
.ion-palette-dark .product-card .bottom[data-v-7e523a73] {
  box-shadow: inset 0 3px 5px #222;
}
.no-ripple[data-v-7e523a73] {
  --ripple-color: transparent;
}
.action-icon[data-v-7e523a73], .expand-icon[data-v-7e523a73] {
  height: 1.5rem;
  width: 1.5rem;
}
.action-icon[data-v-7e523a73] {
  padding: 0 12px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
